import { inject, Pipe, PipeTransform } from '@angular/core';
import { PublicProductCompositePaymentPeriod } from '../enums/public-product-composite-payment-period';
import { Observable } from 'rxjs';
import { PublicProductCompositePaymentPeriodProviderService } from '../providers/public-product-composite-payment-period-provider.service';

@Pipe({
  name: 'publicProductCompositePaymentPeriodLabel',
})
export class PublicProductCompositePaymentPeriodLabelPipe implements PipeTransform {
  /* prettier-ignore */
  private readonly provider = inject(PublicProductCompositePaymentPeriodProviderService);

  public transform(
    period: PublicProductCompositePaymentPeriod,
  ): Observable<string> {
    return this.provider.labelFor(period);
  }
}
